// assets/js/controllers/inactive-reason_controller.ts
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['checkbox', 'field'];

    declare readonly checkboxTarget: HTMLInputElement;
    declare readonly fieldTarget: HTMLElement;

    connect(): void {
        this.update();
    }

    toggle(): void {
        this.update(true);
    }

    private update(clearOnActive = false): void {
        const isActive = this.checkboxTarget.checked;

        this.fieldTarget.classList.toggle('d-none', isActive);

        if (isActive && clearOnActive) {
            const select = this.fieldTarget.querySelector('select');

            if (select instanceof HTMLSelectElement) {
                select.value = '';
            }
        }
    }
}
